import { render, staticRenderFns } from "./SpecialBtn.vue?vue&type=template&id=7bdc8977&scoped=true&"
import script from "./SpecialBtn.vue?vue&type=script&lang=js&"
export * from "./SpecialBtn.vue?vue&type=script&lang=js&"
import style0 from "./SpecialBtn.vue?vue&type=style&index=0&id=7bdc8977&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdc8977",
  null
  
)

/* custom blocks */
import block0 from "./SpecialBtn.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports